import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import OverlayPlay from '../overlay-play';
import { formatDateShortMonth } from '../../../utils/date-format-util';
import { formatTimeCode } from '../../../utils/time-format-util';
import PlayerSizes from '../../../enum/player-sizes';

const getMetaDataClassNames = (playerSize, titleEnabled, dateTimeEnabled) => {

    return `overlay-metadata ${playerSize}${titleEnabled ? '' : ' no-title'}${dateTimeEnabled ? '' : ' no-datetime'}`;

};

const getPlayButtonClassNames = (playerSize, titleEnabled, dateTimeEnabled) => {

    const centerPlayButon = !titleEnabled && !dateTimeEnabled;
    return `${playerSize}${centerPlayButon ? ' centered-play-button' : ''}`;

};

const ClickToPlayOverlay = (props) => {

    const {
        clip,
        mediaConfig,
        playerSize,
    } = props;
    const metaDataConfig = _get(mediaConfig, 'embed.metaDataDisplay', {
        title: true,
        dateTimeDisplay: true,
    });
    const {
        titleEnabled,
        dateTimeEnabled,
    } = metaDataConfig;
    const poster = _get(clip, 'poster.at3x', _get(clip, 'poster.src', ''));
    const title = _get(clip, 'title');
    const date = new Date(_get(clip, 'date'));
    const duration = formatTimeCode(_get(clip, 'duration'));

    return (
        <div className={`overlay click-to-play-overlay ${playerSize}`} onClick={props.onClick}>
            <img className="scrim" src={poster} alt={title} />
            <div className={getMetaDataClassNames(playerSize, titleEnabled, dateTimeEnabled)}>
                {dateTimeEnabled
                    ? <div className="date-time">
                        <p className="date">{formatDateShortMonth(date)}</p>
                        <p>&nbsp;&middot;&nbsp;</p>
                        {!!duration
                            ? <p className="duration">{duration}</p>
                            : null
                        }
                    </div>
                    : null
                }
                {titleEnabled
                    ? <h1 className="title">{title}</h1>
                    : null
                }

            </div>
            <OverlayPlay
                classes={getPlayButtonClassNames(playerSize, titleEnabled, dateTimeEnabled)}
                buttonClasses={playerSize} />
        </div>
    );

};

ClickToPlayOverlay.propTypes = {
    /** The MediaConfig object */
    mediaConfig: PropTypes.object,
    /** Click handler for the overlay */
    onClick: PropTypes.func,
    /** The current MediaItem clip for playback and display */
    clip: PropTypes.object,
    /** PlayerSizes enum - the size of the player to help with layout */
    playerSize: PropTypes.string,
};

ClickToPlayOverlay.defaultProps = {
    mediaConfig: {},
    onClick: () => { },
    clip: {},
    playerSize: PlayerSizes.SM,
};

export default ClickToPlayOverlay;
